(() => {
    const NT_ADDITIONAL_INFO_SELECTOR = '#b2b-nt-addition-info';
     
    function getValueByTitle(title) {
      const map = {
        Email: window.bss_customer_nt?.email,                                 
        'Company No.': window.bss_customer_nt?.companyNo,
      };
      return map[title];
    }

    function setInputValue(input, value) {
      if (!input || input.value || !value) return;
      input.value = value;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Tìm đúng <li value="VN"> trong danh sách quốc gia rồi "click" để widget
    // tự cập nhật flag + #phone-country-code + span dial-code hiển thị.
    function selectPhoneCountry(form, iso) {
        if (!iso) return null;
        const li = form.querySelector(`#phone-country-list li[value="${iso}"]`);
        if (!li) return null;
        const match = li.textContent.match(/\(\+(\d+)\)/); // "Viet Nam (+84)" -> "84"
        const list = form.querySelector('#phone-country-list');

        li.click(); // để widget tự cập nhật flag + #phone-country-code + span dial-code

        // click vào li cũng làm dropdown tự mở ra -> ép đóng lại ngay,
        // và đóng thêm 1 lần sau microtask phòng trường hợp widget mở lại bằng setTimeout/rAF
        if (list) list.style.display = 'none';
        setTimeout(() => { if (list) list.style.display = 'none'; }, 0);

        return match ? `+${match[1]}` : null;
    }

    function fillAdditionalInfo() {
      const form = document.querySelector(NT_ADDITIONAL_INFO_SELECTOR);
      if (!form) return false;

      const phoneInput = form.querySelector('#phone-field');
      if (phoneInput && !phoneInput.value) {
        const iso = window.bss_customer_nt?.phoneCountryCode; // vd "VN"
        const dialCode = selectPhoneCountry(form, iso); // vd "+84"
        let rawPhone = window.bss_customer_nt?.phone || '';
        if (dialCode && rawPhone.startsWith(dialCode)) {
          rawPhone = rawPhone.slice(dialCode.length);
        }
        setInputValue(phoneInput, rawPhone.trim());
      }

      form.querySelectorAll('label.label-field[title]').forEach((label) => {
        const title = label.getAttribute('title');
        if (title === 'Phone') return;
        const forId = label.getAttribute('for');
        const input = forId ? form.querySelector(`#${CSS.escape(forId)}`) : null;
        setInputValue(input, getValueByTitle(title));
      });

      return true;
    }

    const ntBtn = document.querySelector('#bss-b2b-net-term-button');
    if (ntBtn) {
      ntBtn.addEventListener('click', () => {
        let tries = 0;
        const iv = setInterval(() => {
          if (fillAdditionalInfo() || ++tries > 20) clearInterval(iv);
        }, 150);
      });
    }
  })();